import React, { useRef, useState, useEffect } from 'react'
import classes from "./CreateHolidayMode.module.css"
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../../../Modal/Modal';
import Button1 from '../../../Button/Button1';
import UseParseYearMonthDate from '../../../../hooks/UseParseYearMonthDate';
import UseYearMonthDateShort from '../../../../hooks/UseYearMonthDateShort';
import TimeDatePicker from '../../../TimeDatePicker/TimeDatePicker';
import holidayModeIcon from "../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/__Edit-93.svg"
import StatePicker from './StatePicker';
import UseParseDateMonthYearTime from '../../../../hooks/UseParseDateMonthYearTime';
import { createHolidayModeAPI } from '../../../../../Api Methods/Api';
import Button2 from '../../../Button/Button2';
import StatePickerMassHolidayMode from './StatePickerMassHolidayMode';
import SelectOutputs from '../EditAutomations/SelectOutputs';
import StatePickerIndividualHolidayMode from './StatePickerIndividualHolidayMode';

const CreateMassHolidayMode = ({ uuids, setComplete, setCount, type, checkedSites }) => {
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);  
    const inputRef = useRef(null);
    const apiData = {
        token,
        client
    }    
    const ModalDialog = useRef();
    const ClearStatesChildComponetRef = useRef();

    const [currentSiteIndex, setCurrentSiteIndex] = useState(0)

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
        //reset states for scheduled Action
        if (ClearStatesChildComponetRef.current && ClearStatesChildComponetRef.current.HandleResetAllStates) {
            // Call the child method
            ClearStatesChildComponetRef.current.HandleResetAllStates();
        }

        //reset model screens
        HandelResetModal();
    }

    const [modalTitle, setModalTitle] = useState("Create temporary schedule")
    const [modalComponent, setModalComponent] = useState()
    const [modalPageIndex, setModalPageIndex] = useState(0);

    const [holidayModeDetails, setHolidayModeDetails] = useState(
        {
            "deviceUUID": "",
            "start": "",
            "end": "",
            "name": "",
            "active": 1,
            "states": { "5": "ignore", "6": "ignore", "13": "ignore", "19": "ignore" }
        }
    );

    // Handler for time change
    const HandleStartOn = (object) => {
        setHolidayModeDetails(prevState => ({
            ...prevState, // Spread the previous state to keep other properties unchanged
            start: object // Update only the start property
        }));
    };

    const HandleEndOn = (object) => {
        setHolidayModeDetails(prevState => ({
            ...prevState,
            end: object
        }));
    };

    const HandleSetName = (object) => {
        setHolidayModeDetails(prevState => ({
            ...prevState, // Spread the previous state to keep other properties unchanged
            name: object.current?.value?.trim() 
        }));
    }

    const HandleOutputState = (pin, state) => {
        const states = holidayModeDetails.states
        states[pin] = state;

        setHolidayModeDetails(prevState => ({
            ...prevState, // Spread the previous state to keep other properties unchanged
            "states": states 
        }));
    }
    const dispatch = useDispatch();

    useEffect(() => {
    }, [holidayModeDetails])

    const HandleCreateMassHolidayMode = async () => {
        if ((holidayModeDetails.start != holidayModeDetails.end) && holidayModeDetails.name !== "") {
            for (const uuid of uuids) {
                const body = {
                    ...holidayModeDetails,
                    deviceUUID: uuid
                };

                await createHolidayModeAPI(apiData, body, dispatch);
            }
            
            setCount(uuids.length)
            setComplete(true)
        }
    }

    const [isHolidayModeValid, setisHolidayModeValid] = useState(false);

    useEffect(() => {
            if ((holidayModeDetails.start != holidayModeDetails.end) && holidayModeDetails.name !== ""){
                setisHolidayModeValid(true);
            } else {
                setisHolidayModeValid(false)
            }
        
    }, [holidayModeDetails])

    const HandleHolidayModeType = () => {
        if (type == 0){
            setModalPageIndex(1)
        } else if (type == 1) {
            setModalPageIndex(2)
        }
    }

    const HandleCreateAndNext = async (uuid) => {
        const body = {
            ...holidayModeDetails,
            deviceUUID: uuid
        };

        try {
            await createHolidayModeAPI(apiData, body, dispatch);
            setCurrentSiteIndex((prevIndex) => prevIndex + 1);
        } catch (error) {
            console.error("Failed to create temporary schedule:", error);
            // Optional: show error message to user
        }
    };

    useEffect(() => {
        switch (modalPageIndex) {
            case 0: {
                setModalComponent(
                    <div className={classes["timeDatePicker-Container"]}> 
                        <input
                            style={{minHeight:"50px"}}
                            placeholder={"Enter a name"}
                            type="text"
                            className={classes.input}
                            ref={inputRef} 
                            onChange={() => HandleSetName(inputRef)}/>
                            <br></br>
                        <TimeDatePicker handler={HandleStartOn} label={"Start at"} />
                        <br></br>
                        <TimeDatePicker handler={HandleEndOn} label={"End at"} />
                        <br></br>
                        <Button2 style={{minWidth:"480px"}}className={classes.nextButton} disabled={!isHolidayModeValid} onClick={() => HandleHolidayModeType()}>Next</Button2>
                    </div>
                )
                //HandleShowModal();
                break;
            }
            case 1: {
                setModalComponent(
                    <div className={classes["statePicker-Container"]}>
                        <h2 style={{color:"#6e6e6e"}}>What should the switches do during the temporary schedule?</h2>
                        <br></br>
                            <StatePickerMassHolidayMode pinText={"Output 1"} HandleOutputState={HandleOutputState} pinNumber={"5"} states={holidayModeDetails.states["5"]}/>
                            <StatePickerMassHolidayMode pinText={"Output 2"} HandleOutputState={HandleOutputState} pinNumber={"6"} states={holidayModeDetails.states["6"]}/>
                            <StatePickerMassHolidayMode pinText={"Output 3"} HandleOutputState={HandleOutputState} pinNumber={"13"} states={holidayModeDetails.states["13"]}/>
                            <StatePickerMassHolidayMode pinText={"Output 4"} HandleOutputState={HandleOutputState} pinNumber={"19"} states={holidayModeDetails.states["19"]}/>  
                        <br></br>
                        <div style={{ 
                        display: "flex", 
                        flexDirection: "column", 
                        alignItems: "center", 
                        gap: "15px" 
                        }}>
                            <Button2 style={{minWidth:"350px"}}className={classes.nextButton} onClick={() => setModalPageIndex(0)}>Back</Button2>
                            <Button2 style={{minWidth:"350px"}}className={classes.nextButton} onClick={HandleCreateMassHolidayMode}>Save</Button2>
                        </div>
                    </div>
                );
                //HandleShowModal();
                break;
            }
            case 2 : {
                if (checkedSites.length > 0 && currentSiteIndex < checkedSites.length) {
                    //for (const site of checkedSites){
                    const site = checkedSites[currentSiteIndex];
                    const pinDetails = Object.values(site.parsedDeviceDetails); 
                    const outputs = Object.entries(site.parsedDeviceDetails)
                        .filter(([key, pin]) => pin.type === "LATCH" || pin.type === "VIRTUAL_LATCH")
                        .map(([key, pin]) => ({ pinNumber: key, ...pin }));

                    const siteName = site.tag || site.deviceName || site.key;

                    setModalComponent(
                        <div className={classes["statePicker-Container"]}>
                            <h3 style={{color:"#6e6e6e"}}>Creating temporary schedule for: <b style={{fontWeight:"600"}}>{siteName}</b></h3>
                            <h3 style={{color:"#6e6e6e"}}>What should the switches do during the temporary schedule?</h3>
                            <br></br>
                            {outputs.map((output) => {
                                return (
                                    <StatePickerIndividualHolidayMode pinText={output.pinName} outputPin={output.pinNumber} HandleOutputState={HandleOutputState} states={holidayModeDetails.states[output.pinNumber]} />
                                )
                            })}
                            <br></br>
                            <div style={{ 
                            display: "flex", 
                            flexDirection: "column", 
                            alignItems: "center", 
                            gap: "15px" 
                            }}>
                                {/* <Button2 style={{minWidth:"350px"}}className={classes.nextButton} onClick={() => setModalPageIndex(0)}>Back</Button2> */}
                                <Button2 style={{minWidth:"350px"}}className={classes.nextButton} onClick={() => HandleCreateAndNext(site.uuid)}>Save</Button2>
                            </div>
                        </div>
                    );
                    //}
                } else if (currentSiteIndex >= checkedSites.length) {
                    // Finished all sites
                    //HandleCloseModal();
                    setComplete(true)
                    setCount(checkedSites.length)
                }
                break;
            }
        }
        
    }, [modalPageIndex, isHolidayModeValid, currentSiteIndex])


    // reset model when Escape key is pressed
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                // Handle the Escape key press here
                HandelResetModal();
                setModalPageIndex(null);
            }
        };

        // Add event listener when component mounts
        document.addEventListener('keydown', handleKeyDown);


        // Clean up event listener when component unmounts
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const HandelResetModal = () => {
        setModalPageIndex(0);
    }


    return (
        <>
          {modalComponent}
        </>
      )
}

export default CreateMassHolidayMode;